// framework table filters
export const FORM_QUERY = 'query';
export const BUSINESS_UNIT_IDS_FILTER = 'businessUnitIds';
export const FORM_TYPE_FILTER = 'formType';
export const PAGE_COUNT = 'count';
export const PAGE_OFFSET = 'offset';
export const SORT_KEY = 'sortKey';
export const SORT_ORDER = 'sortOrder';

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/1272b073b4a501e516ed83ba8d9c2fcee528c188/FormsUI/static/js/constants/QueryParams.ts#L27
 */
export const FRAMEWORK_TABLE_PARAMS = [FORM_QUERY, FORM_TYPE_FILTER, FORM_TYPE_FILTER, PAGE_COUNT, PAGE_OFFSET, SORT_KEY, SORT_ORDER];